
export const buildTree = (files, virtualFolders = []) => {
  const tree = {};
  const buildPath = (paths, isVirtual = false) => paths.forEach(filePath => {
    if (!filePath) return;
    let [current, currentPath] = [tree, ''];
    filePath.split('/').forEach((part, i, parts) => {
      const path = currentPath ? `${currentPath}/${part}` : part;
      if (!current[part]) {
        current[part] = i === parts.length - 1 && !isVirtual
          ? { name: part, path: filePath }
          : { name: part, children: {}, path, isVirtual };
      }
      current = current[part].children || current[part];
      currentPath = path;
    });
  });

  buildPath(files);
  buildPath(virtualFolders, true);

  const smartSort = (a, b) => {
    const aIsFolder = !!a.children;
    const bIsFolder = !!b.children;
    if (aIsFolder !== bIsFolder) {
      return aIsFolder ? -1 : 1;
    }
    return a.name.localeCompare(b.name, 'pl', { numeric: true, sensitivity: 'base' });
  };

  const convertToTree = obj => Object.keys(obj).map(key => {
    const item = obj[key];
    const node = { id: item.path || key, name: item.name, path: item.path };
    return item.children ? { ...node, isVirtual: item.isVirtual, children: convertToTree(item.children) } : node;
  }).sort(smartSort);

  return convertToTree(tree);
};

export const closeAllNodes = root => {
  if (!root?.children) return;
  root.children.forEach(node => {
    node.isOpen && node.close();
    node.children && closeAllNodes(node);
  });
};

export const countLeaves = root => {
  if (!root?.children) return 0;
  return root.children.reduce((count, node) =>
    count + (node.isLeaf ? 1 : countLeaves(node)), 0);
};
